// extracted by mini-css-extract-plugin
export var aboveInput = "_ir-0";
export var actionButton = "_ir-5";
export var actionButtonContainer = "_ir-1";
export var actionIcon = "_ir-6";
export var aiInfoContainer = "_ir-2";
export var attachmentWrapper = "_ir-7";
export var bold = "_ir-3";
export var checkIcon = "_ir-8";
export var clickingRecipientBar = "_ir-11";
export var commentThreadSwitch = "_ir-a";
export var draftImage = "_ir-b";
export var draftImageContainer = "_ir-c";
export var draftImages = "_ir-e";
export var editButton = "_ir-g";
export var editor = "_ir-f";
export var editorContainer = "_ir-y";
export var editorErrorTooltipWrapper = "_ir-9";
export var headerDivider = "_ir-h";
export var icon = "_ir-i";
export var info = "_ir-j";
export var internal = "_ir-n";
export var internalDivider = "_ir-k";
export var internalMessage = "_ir-l";
export var messageInputCard = "_ir-m";
export var messageInputForm = "_ir-o";
export var messageInputFormInternal = "_ir-p";
export var options = "_ir-q";
export var publicMessageCustomer = "_ir-s";
export var publicMessageMerchant = "_ir-r";
export var removeImageButton = "_ir-d";
export var replyButtons = "_ir-t";
export var showSignatureButton = "_ir-u";
export var spinner = "_ir-v";
export var verticalButtonDivider = "_ir-4";
export var visibilitySelector = "_ir-w";
export var warning = "_ir-x";
export var wrappingText = "_ir-z";
export var writingInternalNoteTopBorder = "_ir-10";